import { STOREFRONTS } from './storefronts.js';
import { createRegionSelector } from './region-selector.js';

(() => {
  // Global auth UX: if any same-origin /api/* request returns 401, redirect to login with next=...
  // This prevents pages opened via IP/port from silently failing when the user only logged in on the domain.
  try {
    if (!window.__authFetchWrapped && typeof window.fetch === 'function') {
      window.__authFetchWrapped = true;
      const origFetch = window.fetch.bind(window);
      window.fetch = async (input, init) => {
        const res = await origFetch(input, init);
        try {
          const rawUrl = typeof input === 'string' ? input : input?.url;
          const url = rawUrl ? new URL(rawUrl, window.location.origin) : null;
          const isApi = url && url.origin === window.location.origin && url.pathname.startsWith('/api/');
          const onLoginPage = (window.location.pathname || '').endsWith('/login.html');
          if (isApi && res && res.status === 401 && !onLoginPage && !window.__authRedirecting) {
            window.__authRedirecting = true;
            const next = encodeURIComponent(`${window.location.pathname}${window.location.search}${window.location.hash}`);
            try {
              alert('登录已失效，请重新登录。');
            } catch (_) {
              /* ignore */
            }
            window.location.href = `/login.html?next=${next}`;
          }
        } catch (_) {
          // ignore
        }
        return res;
      };
    }
  } catch (_) {
    // ignore
  }

  const init = () => {
  // 确保地区选择的样式已加载
  const head = document.head || document.getElementsByTagName('head')[0];
  const hasRegionCss = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((el) =>
    (el.getAttribute('href') || '').includes('region-selector.css'),
  );
  if (!hasRegionCss) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = '/region-selector.css';
    head.appendChild(link);
  }

  const ROLE_MAP = {
    'owner': '所有者',
    'admin': '管理员',
    'operator': '运营者',
    'guest': '访客',
    'developer': '开发者',
    'member': '成员',
    'OWNER': '所有者',
    'ADMIN': '管理员',
    'OPERATOR': '运营者',
    'GUEST': '访客',
    'DEVELOPER': '开发者',
    'MEMBER': '成员',
  };

  const getRoleLabel = (role) => ROLE_MAP[role] || role || '运营者';
  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '?');

  const nav = document.createElement('header');
  nav.className = 'topbar';
  nav.innerHTML = `
    <div class="inner">
      <div class="topbar-left">
        <a class="brand" href="/index.html">ASODIG</a>
        <nav class="topnav">
          <a href="/index.html" data-page="index.html">概览</a>
          <!-- <a href="/app-spaces.html" data-page="app-spaces.html">我的APP</a> -->
          <a href="/app-keywords.html" data-page="app-keywords.html">关键词管理</a>
          <a href="/charts.html" data-page="charts.html">榜单</a>
          <a href="/offer-wall.html" data-page="offer-wall.html" id="offerWallNav" style="display: none;">积分墙</a>
          <a href="/intelligence.html" data-page="intelligence.html">情报</a>
        </nav>
      </div>
      <div class="actions topbar-right">
        <div class="search-bar">
          <div id="navRegion" class="region-selector"></div>
          <select id="navDevice">
            <option value="iphone">iPhone</option>
            <option value="ipad">iPad</option>
          </select>
          <input id="navKeyword" type="text" placeholder="应用名称、关键词或 App ID" />
          <button id="navSearchBtn">搜索</button>
        </div>
        <div class="user-entry" id="userEntry">
          <div class="user-avatar" id="userAvatar">
            <span class="user-avatar-placeholder">?</span>
          </div>
          <div class="user-info">
            <span class="user-name" id="userName">-</span>
            <span class="user-role" id="userRole">-</span>
          </div>
          <div class="user-dropdown" id="userDropdown">
            <a class="user-dropdown-item" href="/profile.html">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>个人信息</span>
            </a>
            <button class="user-dropdown-item" id="logoutBtn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>退出登录</span>
            </button>
          </div>
        </div>
        <a class="platform-switch-btn" href="https://itc.unionurture.com/platform-select" title="切换平台">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="7" height="7" rx="1"></rect>
            <rect x="14" y="3" width="7" height="7" rx="1"></rect>
            <rect x="3" y="14" width="7" height="7" rx="1"></rect>
            <rect x="14" y="14" width="7" height="7" rx="1"></rect>
          </svg>
          <span>切换平台</span>
        </a>
      </div>
    </div>
  `;
  document.body.prepend(nav);
  // 加载用户信息
  const loadUserInfo = async () => {
    try {
      const res = await fetch('/api/user/profile');
      if (!res.ok) return;
      const user = await res.json();
      const displayName = user.displayName || user.username || '未知';
      const rawRole = user.role || user.externalRole || '';
      const role = getRoleLabel(rawRole);
      document.getElementById('userName').textContent = displayName;
      document.getElementById('userRole').textContent = role;
      const avatarEl = document.getElementById('userAvatar');
      if (user.avatar) {
        avatarEl.innerHTML = `<img src="${user.avatar}" alt="头像" />`;
      } else {
        avatarEl.innerHTML = `<span class="user-avatar-placeholder">${getInitial(displayName)}</span>`;
      }

      // 如果是 admin，显示积分墙入口
      const isAdmin = String(rawRole).toLowerCase() === 'admin';
      const offerWallNav = document.getElementById('offerWallNav');
      if (offerWallNav && isAdmin) {
        offerWallNav.style.display = '';
      }

      // 存储用户信息供其他页面使用
      try {
        localStorage.setItem('userInfo', JSON.stringify(user));
      } catch (_) {}
    } catch (_) {
      // ignore
    }
  };
  loadUserInfo();

  // 退出登录
  const logoutBtn = document.getElementById('logoutBtn');
  if (logoutBtn) {
    logoutBtn.addEventListener('click', async () => {
      try {
        await fetch('/api/logout', { method: 'POST' });
      } catch (_) {}
      // 清除 cookie
      document.cookie = 'auth_token=; Max-Age=0; path=/';
      document.cookie = 'auth_user=; Max-Age=0; path=/';
      // 跳转到登录页
      window.location.href = 'https://itc.unionurture.com/login';
    });
  }

  const path = window.location.pathname.split('/').pop() || 'index.html';
  const normalized = path === '' ? 'index.html' : path;
  const active = nav.querySelector(`.topnav a[data-page="${normalized}"]`);
  if (active) active.classList.add('active');

  const NAV_REGION_KEY = 'nav_region_pref';
  const urlSf = new URLSearchParams(window.location.search).get('storefront');
  let currentSf = urlSf || localStorage.getItem(NAV_REGION_KEY) || 'us';
  const regionCtl = createRegionSelector('navRegion', {
    defaultCode: currentSf,
    onChange: (code) => {
      currentSf = code;
      try {
        localStorage.setItem(NAV_REGION_KEY, code);
      } catch (_) {
        /* ignore */
      }
    },
  });
  if (urlSf && urlSf !== currentSf && regionCtl?.setCode) {
    regionCtl.setCode(urlSf);
    currentSf = urlSf;
  }

  // 设备选择器
  const NAV_DEVICE_KEY = 'nav_device_pref';
  const urlDev = new URLSearchParams(window.location.search).get('device');
  let currentDev = urlDev || localStorage.getItem(NAV_DEVICE_KEY) || 'iphone';
  const navDeviceSelect = document.getElementById('navDevice');
  navDeviceSelect.value = currentDev;

  navDeviceSelect.addEventListener('change', () => {
    currentDev = navDeviceSelect.value;
    try {
      localStorage.setItem(NAV_DEVICE_KEY, currentDev);
    } catch (_) {}
    // 触发全局事件，让页面可以监听
    window.dispatchEvent(new CustomEvent('topbar-device-change', { detail: { device: currentDev } }));
  });

  // 暴露全局 API 供页面调用
  window.__topbarDevice = {
    get: () => currentDev,
    set: (dev) => {
      if (dev === 'iphone' || dev === 'ipad') {
        currentDev = dev;
        navDeviceSelect.value = dev;
        try {
          localStorage.setItem(NAV_DEVICE_KEY, dev);
        } catch (_) {}
      }
    }
  };

  const doSearch = () => {
    const kw = document.getElementById('navKeyword').value.trim();
    const dev = document.getElementById('navDevice').value || 'iphone';
    if (!kw) return;
    // App ID 规则：9-10 位纯数字，且数值 >= 1亿
    const isAppId = /^\d{9,10}$/.test(kw) && parseInt(kw) >= 100000000;
    if (isAppId) {
      window.location.href = `/app-metadata.html?appId=${encodeURIComponent(kw)}&storefront=${encodeURIComponent(currentSf)}`;
    } else {
      window.location.href = `/keyword-search.html?keyword=${encodeURIComponent(kw)}&storefront=${encodeURIComponent(currentSf)}&device=${encodeURIComponent(dev)}`;
    }
  };

  document.getElementById('navSearchBtn').addEventListener('click', doSearch);
  document.getElementById('navKeyword').addEventListener('keydown', (e) => {
    if (e.key === 'Enter') doSearch();
  });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
